webpackJsonp([43],{

/***/ 1055:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1056);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("d5fc2caa", content, true, {});

/***/ }),

/***/ 1056:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, ".btn-custom-submit[data-v-a5597bb6]{height:40px!important;width:100%!important;margin-top:27px}.option-action-wrapper[data-v-a5597bb6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%;margin-top:20px}.option-action[data-v-a5597bb6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;cursor:pointer;width:-webkit-max-content;width:-moz-max-content;width:max-content;padding:7px;border-radius:5px}.option-action[data-v-a5597bb6]:hover{background:#edf6ec}.option-action[data-v-a5597bb6]:active{background:#4fb848;color:#fff}.option-action:active span[data-v-a5597bb6]{color:#fff}.option-action svg[data-v-a5597bb6]{width:24px;height:24px}.option-action span[data-v-a5597bb6]{font-size:14px;font-weight:400;color:#000}.modal-confirmation-wrapper[data-v-a5597bb6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%}.modal-confirmation-wrapper .title-confirmation[data-v-a5597bb6]{font-weight:700;font-size:16px;line-height:19px;color:#000}.modal-confirmation-wrapper .description-confirmation[data-v-a5597bb6]{text-align:center;width:60%;font-weight:400;font-size:14px;line-height:16.8px;margin-top:10px}.modal-confirmation-wrapper .description-confirmation span[data-v-a5597bb6]{color:#4fb848}.button-confirmation-wrapper[data-v-a5597bb6]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:10px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:20px}.button-confirmation-wrapper .btn-cancel[data-v-a5597bb6],.button-confirmation-wrapper .btn-publish[data-v-a5597bb6]{border:1px solid #edf6ec;background:#fff;color:#eb0011;height:35px;border-radius:6px;font-size:14px;font-weight:900}.button-confirmation-wrapper .btn-publish[data-v-a5597bb6]{border:1px solid #4fb848;background:#4fb848;color:#fff}.button-confirmation-wrapper .btn-cancel[data-v-a5597bb6]:hover{background:#eb0011;border:1px solid #eb0011;color:#fff}.button-confirmation-wrapper .btn-publish[data-v-a5597bb6]:hover{background:#edf6ec;color:#4fb848}.history-list-wrapper[data-v-a5597bb6]{width:100%;border-radius:10px;border:1px solid #999;margin-top:30px;padding:5px 0 0}.history-list-wrapper .history-title[data-v-a5597bb6]{width:100%;padding:0 10px;font-size:1.067rem;font-weight:700;color:#4a4a4a}.history-list-wrapper ul[data-v-a5597bb6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%;padding:3px 10px;list-style:none}.history-list-wrapper ul li .action-draft-history[data-v-a5597bb6]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:4px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.history-list-wrapper ul li span[data-v-a5597bb6]{color:gray;font-size:13px;font-weight:400}.history-list-wrapper ul li .action-draft-history button[data-v-a5597bb6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:transparent;padding:3px;border:none;border-radius:3px}.history-list-wrapper ul li .action-draft-history button[data-v-a5597bb6]:hover{background:#edf6ec}.history-list-wrapper ul li .action-draft-history button svg[data-v-a5597bb6]{color:#363636;width:17px}.list-terms-conditions[data-v-a5597bb6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:8px;padding:10px 5px;overflow:hidden;border-bottom:.5px solid #ddd}ul li.list-terms-conditions[data-v-a5597bb6]:not(:first-child){margin-top:15px}ul li.list-terms-conditions.active-list-item[data-v-a5597bb6]{border-bottom:none;border-radius:5px;border:1px dotted #4fb848;background:#4fb848}ul li.list-terms-conditions.active-list-item .author-tnc[data-v-a5597bb6],ul li.list-terms-conditions.active-list-item .date-time-tnc[data-v-a5597bb6]{color:#edf6ec}ul li.list-terms-conditions.active-list-item button[data-v-a5597bb6]{border:1px dotted #edf6ec}ul li.list-terms-conditions.active-list-item button svg[data-v-a5597bb6]{color:#edf6ec}ul li.list-terms-conditions.active-list-item button:hover svg[data-v-a5597bb6]{color:#4fb848}.list-terms-conditions .version-badge[data-v-a5597bb6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:15%;height:45px;border-radius:5px;background:#edf6ec;color:#4fb848;font-weight:800;font-size:20px}.description-list-tnc-wrapper[data-v-a5597bb6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;min-width:73%}.description-list-tnc-wrapper .author-tnc[data-v-a5597bb6]{font-size:12px;font-weight:600}.description-list-tnc-wrapper .date-time-tnc[data-v-a5597bb6]{font-size:11px}@media (min-width:768px){.modal-md.custom[data-v-a5597bb6]{width:800px}}", "", {"version":3,"sources":["/app/src/components/master/setting/TermConditionsForm.vue"],"names":[],"mappings":"AACA,oCACE,sBAAwB,AACxB,qBAAuB,AACvB,eAAiB,CAClB,AACD,wCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,WAAY,AACZ,eAAiB,CAClB,AACD,gCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,SAAU,AACV,eAAgB,AAChB,0BAA2B,AAC3B,uBAAwB,AACxB,kBAAmB,AACnB,YAAa,AACb,iBAAmB,CACpB,AACD,sCACE,kBAAoB,CACrB,AACD,uCACE,mBAAoB,AACpB,UAAY,CACb,AACD,4CACE,UAAY,CACb,AACD,oCACE,WAAY,AACZ,WAAa,CACd,AACD,qCACE,eAAgB,AAChB,gBAAiB,AACjB,UAAY,CACb,AACD,6CACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,UAAY,CACb,AACD,iEACE,gBAAiB,AACjB,eAAgB,AAChB,iBAAkB,AAClB,UAAY,CACb,AACD,uEACE,kBAAmB,AACnB,UAAW,AACX,gBAAiB,AACjB,eAAgB,AAChB,mBAAoB,AACpB,eAAiB,CAClB,AACD,4EACE,aAAe,CAChB,AACD,8CACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,SAAU,AACV,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,eAAiB,CAClB,AACD,qHAEE,yBAA0B,AAC1B,gBAAiB,AACjB,cAAe,AACf,YAAa,AACb,kBAAmB,AACnB,eAAgB,AAChB,eAAiB,CAClB,AACD,2DACE,yBAA0B,AAC1B,mBAAoB,AACpB,UAAY,CACb,AACD,gEACE,mBAAoB,AACpB,yBAA0B,AAC1B,UAAY,CACb,AACD,iEACE,mBAAoB,AACpB,aAAe,CAChB,AACD,uCACE,WAAY,AACZ,mBAAoB,AACpB,sBAA0B,AAC1B,gBAAiB,AACjB,eAAmB,CACpB,AACD,sDACE,WAAY,AACZ,eAAgB,AAChB,mBAAoB,AACpB,gBAAiB,AACjB,aAAe,CAChB,AACD,0CACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,WAAY,AACZ,iBAAkB,AAClB,eAAiB,CAClB,AACD,mEACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,QAAS,AACT,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,kDACE,WAAe,AACf,eAAgB,AAChB,eAAiB,CAClB,AACD,0EACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,uBAAwB,AACxB,YAAa,AACb,YAAa,AACb,iBAAmB,CACpB,AACD,gFACE,kBAAoB,CACrB,AACD,8EACE,cAAe,AACf,UAAY,CACb,AACD,wCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,QAAS,AACT,iBAAkB,AAClB,gBAAiB,AACjB,6BAAgC,CACjC,AACD,+DACE,eAAiB,CAClB,AACD,8DACE,mBAAoB,AACpB,kBAAmB,AACnB,0BAA2B,AAC3B,kBAAoB,CACrB,AACD,uJAEE,aAAe,CAChB,AACD,qEACE,yBAA2B,CAC5B,AACD,yEACE,aAAe,CAChB,AACD,+EACE,aAAe,CAChB,AACD,uDACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,UAAW,AACX,YAAa,AACb,kBAAmB,AACnB,mBAAoB,AACpB,cAAe,AACf,gBAAiB,AACjB,cAAgB,CACjB,AACD,+CACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AACpC,aAAe,CAChB,AACD,2DACE,eAAgB,AAChB,eAAiB,CAClB,AACD,8DACE,cAAgB,CACjB,AACD,yBACA,kCACI,WAAa,CAChB,CACA","file":"TermConditionsForm.vue","sourcesContent":["\n.btn-custom-submit[data-v-a5597bb6] {\n  height: 40px !important;\n  width: 100% !important;\n  margin-top: 27px;\n}\n.option-action-wrapper[data-v-a5597bb6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 100%;\n  margin-top: 20px;\n}\n.option-action[data-v-a5597bb6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n  padding: 7px;\n  border-radius: 5px;\n}\n.option-action[data-v-a5597bb6]:hover {\n  background: #edf6ec;\n}\n.option-action[data-v-a5597bb6]:active {\n  background: #4fb848;\n  color: #fff;\n}\n.option-action:active span[data-v-a5597bb6] {\n  color: #fff;\n}\n.option-action svg[data-v-a5597bb6] {\n  width: 24px;\n  height: 24px;\n}\n.option-action span[data-v-a5597bb6] {\n  font-size: 14px;\n  font-weight: 400;\n  color: #000;\n}\n.modal-confirmation-wrapper[data-v-a5597bb6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n}\n.modal-confirmation-wrapper .title-confirmation[data-v-a5597bb6] {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 19px;\n  color: #000;\n}\n.modal-confirmation-wrapper .description-confirmation[data-v-a5597bb6] {\n  text-align: center;\n  width: 60%;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16.8px;\n  margin-top: 10px;\n}\n.modal-confirmation-wrapper .description-confirmation span[data-v-a5597bb6] {\n  color: #4fb848;\n}\n.button-confirmation-wrapper[data-v-a5597bb6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 10px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-top: 20px;\n}\n.button-confirmation-wrapper .btn-cancel[data-v-a5597bb6],\n.button-confirmation-wrapper .btn-publish[data-v-a5597bb6] {\n  border: 1px solid #edf6ec;\n  background: #fff;\n  color: #eb0011;\n  height: 35px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 900;\n}\n.button-confirmation-wrapper .btn-publish[data-v-a5597bb6] {\n  border: 1px solid #4fb848;\n  background: #4fb848;\n  color: #fff;\n}\n.button-confirmation-wrapper .btn-cancel[data-v-a5597bb6]:hover {\n  background: #eb0011;\n  border: 1px solid #eb0011;\n  color: #fff;\n}\n.button-confirmation-wrapper .btn-publish[data-v-a5597bb6]:hover {\n  background: #edf6ec;\n  color: #4fb848;\n}\n.history-list-wrapper[data-v-a5597bb6] {\n  width: 100%;\n  border-radius: 10px;\n  border: 1px solid #999999;\n  margin-top: 30px;\n  padding: 5px 0 0 0;\n}\n.history-list-wrapper .history-title[data-v-a5597bb6] {\n  width: 100%;\n  padding: 0 10px;\n  font-size: 1.067rem;\n  font-weight: 700;\n  color: #4a4a4a;\n}\n.history-list-wrapper ul[data-v-a5597bb6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 100%;\n  padding: 3px 10px;\n  list-style: none;\n}\n.history-list-wrapper ul li .action-draft-history[data-v-a5597bb6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 4px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.history-list-wrapper ul li span[data-v-a5597bb6] {\n  color: #808080;\n  font-size: 13px;\n  font-weight: 400;\n}\n.history-list-wrapper ul li .action-draft-history button[data-v-a5597bb6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background: transparent;\n  padding: 3px;\n  border: none;\n  border-radius: 3px;\n}\n.history-list-wrapper ul li .action-draft-history button[data-v-a5597bb6]:hover {\n  background: #edf6ec;\n}\n.history-list-wrapper ul li .action-draft-history button svg[data-v-a5597bb6] {\n  color: #363636;\n  width: 17px;\n}\n.list-terms-conditions[data-v-a5597bb6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  gap: 8px;\n  padding: 10px 5px;\n  overflow: hidden;\n  border-bottom: 0.5px solid #ddd;\n}\nul li.list-terms-conditions[data-v-a5597bb6]:not(:first-child) {\n  margin-top: 15px;\n}\nul li.list-terms-conditions.active-list-item[data-v-a5597bb6] {\n  border-bottom: none;\n  border-radius: 5px;\n  border: 1px dotted #4fb848;\n  background: #4fb848;\n}\nul li.list-terms-conditions.active-list-item .author-tnc[data-v-a5597bb6],\nul li.list-terms-conditions.active-list-item .date-time-tnc[data-v-a5597bb6] {\n  color: #edf6ec;\n}\nul li.list-terms-conditions.active-list-item button[data-v-a5597bb6] {\n  border: 1px dotted #edf6ec;\n}\nul li.list-terms-conditions.active-list-item button svg[data-v-a5597bb6] {\n  color: #edf6ec;\n}\nul li.list-terms-conditions.active-list-item button:hover svg[data-v-a5597bb6] {\n  color: #4fb848;\n}\n.list-terms-conditions .version-badge[data-v-a5597bb6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 15%;\n  height: 45px;\n  border-radius: 5px;\n  background: #edf6ec;\n  color: #4fb848;\n  font-weight: 800;\n  font-size: 20px;\n}\n.description-list-tnc-wrapper[data-v-a5597bb6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  min-width: 73%;\n}\n.description-list-tnc-wrapper .author-tnc[data-v-a5597bb6] {\n  font-size: 12px;\n  font-weight: 600;\n}\n.description-list-tnc-wrapper .date-time-tnc[data-v-a5597bb6] {\n  font-size: 11px;\n}\n@media (min-width: 768px) {\n.modal-md.custom[data-v-a5597bb6] {\n    width: 800px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1057:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"section-header-info"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb"},[_vm._m(0),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/administration/setting"}},[_vm._v("\n                  Global Settings\n                ")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("\n                Terms & Conditions\n              ")])])]),_vm._v(" "),_vm._m(1)])])])]),_vm._v(" "),_c('section',{staticClass:"middle-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.title),expression:"model.title"}],staticClass:"form-control",class:{
                    'field-error': _vm.isSubmitted && !_vm.$v.model.title.required,
                  },attrs:{"type":"text","name":"title"},domProps:{"value":(_vm.model.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "title", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.title.required)?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                  Title is required\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{},[_vm._v("Deadline Date")]),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"deadline-date","min-date":_vm.minimumDeadlineDate,"color":"#025BC5","format":"YYYY-MM-DD","formatted":"MMM DD, YYYY","auto-close":"","only-date":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.model.deadlineDate),callback:function ($$v) {_vm.$set(_vm.model, "deadlineDate", $$v)},expression:"model.deadlineDate"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Content")]),_vm._v(" "),_c('quill-editor',{ref:"myQuillEditor",class:{
                    'field-error': _vm.isSubmitted && !_vm.$v.model.content.required,
                  },attrs:{"options":_vm.editorOption},model:{value:(_vm.model.content),callback:function ($$v) {_vm.$set(_vm.model, "content", $$v)},expression:"model.content"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.content.required)?_c('small',{staticClass:"form-text sts-danger",staticStyle:{"display":"block"}},[_vm._v("\n                  Content is required\n                ")]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 postick"},[_c('button',{staticClass:"btn btn-primary btn-custom-submit",attrs:{"type":"submit"}},[_vm._v("\n              Submit\n            ")]),_vm._v(" "),_c('div',{staticClass:"option-action-wrapper"},[_c('div',{staticClass:"option-action",on:{"click":function($event){return _vm.saveToDraft()}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"M8 6h12v2H8z","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8 10h12v2H8z","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8 14h6v2H8z","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8 24h4v2H8z","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M29.707 19.293l-3-3a1 1 0 0 0-1.414 0L16 25.586V30h4.414l9.293-9.293a1 1 0 0 0 0-1.414zM19.586 28H18v-1.586l5-5L24.586 23zM26 21.586L24.414 20L26 18.414L27.586 20z","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 30H6a2.002 2.002 0 0 1-2-2V4a2.002 2.002 0 0 1 2-2h16a2.002 2.002 0 0 1 2 2v10h-2V4H6v24h6z","fill":"currentColor"}})]),_vm._v(" "),_c('span',[_vm._v("Save to Draft")])]),_vm._v(" "),_c('div',{staticClass:"option-action",on:{"click":function($event){return _vm.onPreview(_vm.model)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 1024 1024"}},[_c('path',{attrs:{"d":"M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3c7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176s-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112s-50.1 112-112 112z","fill":"currentColor"}})]),_vm._v(" "),_c('span',[_vm._v("Preview")])])]),_vm._v(" "),(_vm.live && (_vm.live.content || _vm.live.title))?_c('div',{staticClass:"history-list-wrapper",attrs:{"id":"draft"}},[_c('h4',{staticClass:"history-title"},[_vm._v("Published")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"list-terms-conditions",class:_vm.live.id === _vm.model.id && 'active-list-item'},[_c('div',{staticClass:"version-badge"},[_vm._v("V"+_vm._s(_vm.live.version))]),_vm._v(" "),_c('div',{staticClass:"description-list-tnc-wrapper"},[_c('div',{staticClass:"author-tnc"},[_vm._v("\n                      Uploaded by "+_vm._s(_vm.live.publishedBy)+"\n                    ")]),_vm._v(" "),_c('span',{staticClass:"date-time-tnc"},[_vm._v(_vm._s(_vm._f("momentDate")(_vm.live.modifiedDate)))])]),_vm._v(" "),_c('div',{staticClass:"action-draft-history"},[_c('button',{staticClass:"btn-preview",attrs:{"type":"button"},on:{"click":function($event){return _vm.onEdit(_vm.live)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 1024 1024"}},[_c('path',{attrs:{"d":"M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3c7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176s-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112s-50.1 112-112 112z","fill":"currentColor"}})])])])])])]):_vm._e(),_vm._v(" "),(_vm.draft && (_vm.draft.content || _vm.draft.title))?_c('div',{staticClass:"history-list-wrapper",attrs:{"id":"draft"}},[_c('h4',{staticClass:"history-title"},[_vm._v("Draft")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"list-terms-conditions",class:_vm.draft.id === _vm.model.id && 'active-list-item'},[_c('div',{staticClass:"version-badge"},[_vm._v("V"+_vm._s(_vm.draft.version))]),_vm._v(" "),_c('div',{staticClass:"description-list-tnc-wrapper"},[_c('div',{staticClass:"author-tnc"},[_vm._v("\n                      Uploaded by "+_vm._s(_vm.draft.publishedBy)+"\n                    ")]),_vm._v(" "),_c('span',{staticClass:"date-time-tnc"},[_vm._v(_vm._s(_vm._f("momentDate")(_vm.draft.modifiedDate)))])]),_vm._v(" "),_c('div',{staticClass:"action-draft-history"},[_c('button',{staticClass:"btn-preview",attrs:{"type":"button"},on:{"click":function($event){return _vm.onEdit(_vm.draft)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 1024 1024"}},[_c('path',{attrs:{"d":"M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3c7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176s-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112s-50.1 112-112 112z","fill":"currentColor"}})])])])])])]):_vm._e(),_vm._v(" "),(_vm.history.length)?_c('div',{staticClass:"history-list-wrapper",attrs:{"id":"history"}},[_c('h4',{staticClass:"history-title"},[_vm._v("History")]),_vm._v(" "),_c('ul',_vm._l((_vm.history),function(item,idx){return _c('li',{key:idx,staticClass:"list-terms-conditions",class:item.id === _vm.model.id && 'active-list-item'},[_c('div',{staticClass:"version-badge"},[_vm._v("V"+_vm._s(item.version))]),_vm._v(" "),_c('div',{staticClass:"description-list-tnc-wrapper"},[_c('div',{staticClass:"author-tnc"},[_vm._v("\n                      Uploaded by "+_vm._s(item.publishedBy)+"\n                    ")]),_vm._v(" "),_c('span',{staticClass:"date-time-tnc"},[_vm._v(_vm._s(_vm._f("momentDate")(item.modifiedDate)))])]),_vm._v(" "),_c('div',{staticClass:"action-draft-history"},[_c('button',{staticClass:"btn-preview",attrs:{"type":"button"},on:{"click":function($event){return _vm.onEdit(item)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 1024 1024"}},[_c('path',{attrs:{"d":"M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3c7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176s-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112s-50.1 112-112 112z","fill":"currentColor"}})])])])])}),0)]):_vm._e()])])])])]),_vm._v(" "),_c('div',{ref:"confirmationModal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-md"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body repricing-modal"},[_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-confirmation-wrapper"},[_c('h3',{staticClass:"title-confirmation"},[_vm._v("Publish Confirmation")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"button-confirmation-wrapper"},[_c('button',{staticClass:"btn btn-cancel",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("\n                      Cancel\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-publish",attrs:{"type":"button"},on:{"click":function($event){return _vm.onPublish()}}},[_vm._v("\n                      Publish\n                    ")])])])])])])])])])]),_vm._v(" "),_c('div',{ref:"previewModal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-md custom"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body repricing-modal"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"d-flex justify-between items-center"},[_c('h4',{staticClass:"title-preview"},[_vm._v(_vm._s(_vm.previewData.title))]),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-preview-wrapper"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.previewData.content)}})])])])])])])])]),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Administration")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-header-info"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"pull-left"},[_c('h2',[_vm._v("\n                  Terms & Conditions\n                  "),_c('span',[_c('i',{staticClass:"ic-settings-horizontal"})])]),_vm._v(" "),_c('p',[_vm._v("\n                  Set all necessary parameters and configurations to support\n                  your business.\n                ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"d-flex items-center",staticStyle:{"justify-content":"flex-end"}},[_c('button',{staticClass:"close btn-close-modal",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"description-confirmation"},[_vm._v("\n                    Please ensure the content has been\n                    "),_c('span',[_vm._v("previewed")]),_vm._v(" and is correct. Are you sure you\n                    want to publish?\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close btn-close-modal",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermConditionsForm_vue__ = __webpack_require__(794);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5597bb6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermConditionsForm_vue__ = __webpack_require__(1057);
function injectStyle (ssrContext) {
  __webpack_require__(1055)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a5597bb6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermConditionsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5597bb6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermConditionsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(469));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(468));

var _alphaNum = _interopRequireDefault(__webpack_require__(471));

var _numeric = _interopRequireDefault(__webpack_require__(472));

var _between = _interopRequireDefault(__webpack_require__(473));

var _email = _interopRequireDefault(__webpack_require__(474));

var _ipAddress = _interopRequireDefault(__webpack_require__(475));

var _macAddress = _interopRequireDefault(__webpack_require__(476));

var _maxLength = _interopRequireDefault(__webpack_require__(477));

var _minLength = _interopRequireDefault(__webpack_require__(478));

var _required = _interopRequireDefault(__webpack_require__(479));

var _requiredIf = _interopRequireDefault(__webpack_require__(480));

var _requiredUnless = _interopRequireDefault(__webpack_require__(481));

var _sameAs = _interopRequireDefault(__webpack_require__(482));

var _url = _interopRequireDefault(__webpack_require__(483));

var _or = _interopRequireDefault(__webpack_require__(484));

var _and = _interopRequireDefault(__webpack_require__(485));

var _not = _interopRequireDefault(__webpack_require__(486));

var _minValue = _interopRequireDefault(__webpack_require__(487));

var _maxValue = _interopRequireDefault(__webpack_require__(488));

var _integer = _interopRequireDefault(__webpack_require__(489));

var _decimal = _interopRequireDefault(__webpack_require__(490));

var helpers = _interopRequireWildcard(__webpack_require__(465));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","BRAND_NAME":"Trransfer","VUE_APP_GOOGLE_MAPS_KEY":"AIzaSyDwoOCBqFXIhPMWg922paZIpeVZkudwH6I","VUE_APP_BASE_API":"https://prod-gateway-opsicar.idteknologia.net","VUE_APP_AUTH_HOST":"https://authservice.trransfer.com","VUE_APP_CDN":"https://maverick-global-assets-cp52hf.s3.ap-southeast-1.amazonaws.com","VUE_APP_GOOGLE_TAG_ID":"UA-171512499-1","VUE_APP_SUPPORT_WIDGET_ID":"51000003059","VUE_APP_SUPPORT_WIDGET_SOURCE":"https://aus-widget.freshworks.com/widgets/51000003059.js"}).BUILD === 'web' ? __webpack_require__(470).withParams : __webpack_require__(235).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'required'
}, function (value) {
  if (typeof value === 'string') {
    return (0, _common.req)(value.trim());
  }

  return (0, _common.req)(value);
});

exports.default = _default;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('integer', /(^[0-9]*$)|(^-[0-9]+$)/);

exports.default = _default;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(57);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 677:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/master/termscondition";

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getById: function getById(id) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/" + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  saveToDraft: function saveToDraft(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/draft", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  publish: function publish(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/publish", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 794:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_master_termsCondition_termsConditionService_js__ = __webpack_require__(677);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    editor: function editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  validations: function validations() {
    var v = {
      model: {
        id: {},
        title: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
        deadlineDate: {},
        content: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
        createdDate: {},
        modifiedDate: {}
      }
    };

    return v;
  },
  data: function data() {
    return {
      editorOption: {
        modules: {
          clipboard: {
            matchVisual: false
          }
        }
      },
      previewData: {
        id: null,
        title: null,
        deadlineDate: null,
        content: "",
        createdDate: null,
        modifiedDate: null
      },
      model: {
        id: null,
        title: null,
        deadlineDate: null,
        content: "",
        createdDate: null,
        modifiedDate: null
      },
      draft: {
        content: "",
        deadlineDate: null,
        createdDate: null,
        modifiedDate: null,
        id: null,
        title: null
      },
      live: {
        content: "",
        deadlineDate: null,
        createdDate: null,
        modifiedDate: null,
        id: null,
        title: null
      },
      history: [],
      minimumDeadlineDate: null,
      isSubmitted: false,
      isLoading: false,
      msg: "Please wait"
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$helper.scrollTop();

              _this.minimumDeadlineDate = _this.$helper.toStringDate(_this.$helper.addDays(1));

              _context.next = 4;
              return _this.getAll();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getAll: function getAll() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.isLoading = true;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_termsCondition_termsConditionService_js__["a" /* default */].getAll();

              case 4:
                response = _context2.sent;


                if (response.isSuccess) {
                  _this2.live = response.data.live;
                  _this2.draft = response.data.draft;
                  _this2.history = response.data.history.sort(function (a, b) {
                    return new Date(b.createdDate) - new Date(a.createdDate);
                  });

                  _this2.model = {
                    id: response.data.latest && response.data.latest.id ? response.data.latest.id : null,
                    title: response.data.latest && response.data.latest.title ? response.data.latest.title : null,
                    deadlineDate: response.data.latest && response.data.latest.deadlineDate ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(response.data.latest.deadlineDate).format("YYYY-MM-DD") : null,
                    content: response.data.latest && response.data.latest.content ? response.data.latest.content : null,
                    createdDate: response.data.latest && response.data.latest.createdDate ? response.data.latest.createdDate : null,
                    modifiedDate: response.data.latest && response.data.latest.modifiedDate ? response.data.latest.modifiedDate : null
                  };
                }
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

                if (_context2.t0.errors) {
                  for (index = 0; index < _context2.t0.errors.length; index++) {
                    _this2.$notification.error(_context2.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context2.prev = 11;

                _this2.isLoading = false;
                return _context2.finish(11);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8, 11, 14]]);
      }))();
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        this.$nextTick(function () {
          return _this3.$helper.focusToFieldError();
        });
        return;
      }

      $(this.$refs.confirmationModal).modal({
        backdrop: "static",
        keyboard: false
      });
    },
    onPublish: function onPublish() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var payload, response, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.isLoading = true;
                _context3.prev = 1;
                payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this4.model, {
                  deadlineDate: _this4.model.deadlineDate ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(_this4.model.deadlineDate).format("YYYY-MM-DDTHH:mm:ss") : null
                });
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_termsCondition_termsConditionService_js__["a" /* default */].publish(payload);

              case 5:
                response = _context3.sent;


                if (response.isSuccess) {
                  _this4.$notification.success("Successfully publish terms & condition.", {
                    title: "Success"
                  });
                  _this4.$router.push({ path: "/administration/setting" });
                }
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](1);

                if (_context3.t0.errors) {
                  for (index = 0; index < _context3.t0.errors.length; index++) {
                    _this4.$notification.error(_context3.t0.errors[index], { title: "Error" });
                  }
                }

              case 12:
                _context3.prev = 12;

                _this4.isLoading = false;
                $(_this4.$refs.confirmationModal).modal("hide");
                return _context3.finish(12);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[1, 9, 12, 16]]);
      }))();
    },
    saveToDraft: function saveToDraft() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.isLoading = true;
                _context4.prev = 1;
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_termsCondition_termsConditionService_js__["a" /* default */].saveToDraft(_this5.model);

              case 4:
                response = _context4.sent;


                if (response.isSuccess) {
                  _this5.$notification.success("Successfully saved to draft.", {
                    title: "Success"
                  });
                }
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](1);

                if (_context4.t0.errors) {
                  for (index = 0; index < _context4.t0.errors.length; index++) {
                    _this5.$notification.error(_context4.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context4.prev = 11;

                _this5.isLoading = false;
                _this5.getAll();
                return _context4.finish(11);

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[1, 8, 11, 15]]);
      }))();
    },
    onPreview: function onPreview(data) {
      this.previewData = data;

      $(this.$refs.previewModal).modal({
        backdrop: "static",
        keyboard: false
      });
    },
    onEdit: function onEdit(data) {
      var _this6 = this;

      this.isLoading = true;
      setTimeout(function () {
        _this6.isLoading = false;
      }, 200);
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
        deadlineDate: data.deadlineDate ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(data.deadlineDate).format("YYYY-MM-DD") : null
      });
    }
  },
  filters: {
    momentDate: function momentDate(time) {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(time).parseZone().format("D MMMM YYYY hh:mm:ss");
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/43.ecbb136cb04976f5eff3.js